import BaseApi from './base/base-api';

class TranslationsApi extends BaseApi {
  constructor() {
    super(process.env.REACT_APP_TRANSLATIONS_API_URL || '', {
      allowRefreshToken: true,
      includeAuthorization: true,
    });
  }
}
const translationsApi = new TranslationsApi();
export default translationsApi;
